module.exports = new __parcel__URL__("c1s11.60c392f0.jpg").toString();